<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	import Input from '$lib/components/inputs/Input.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import Link from '$lib/components/navigation/Link.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Text from '$lib/components/Text.svelte';

	export const config: SectionConfig = {
		collection: 'section_newsletter',
		availableFor: ['pages', 'special-pages'],
		query: gql`
			media {
				...Media
			}
    `
	};
</script>

<script lang="ts">
	import NewsletterForm from '$lib/components/util/NewsletterForm.svelte';

	export let data: any;
</script>

<Section class="section-blog-text" type="slim">
	<div class="background" slot="background">
		<div class="background-image-wrapper">
			<Media {...data.media} fit="cover" transform="xl" />
		</div>
	</div>
	<div class="wrapper">
		<div class="content">
			<NewsletterForm />
		</div>
	</div>
</Section>

<style lang="scss">
	:global(.section-blog-text) {
		margin-bottom: 0 !important;
	}

	:global(.background) {
		:global(.background-image-wrapper) {
			height: 100%;
		}
		height: 100%;
		img {
			height: 100%;
			object-fit: cover;
		}
	}
	.wrapper {
		display: flex;
		min-height: calc(100vh - v(header__height));
		justify-content: center;
		align-items: center;
		padding-block: v(content-gap-2xl);
		.content {
			:global(.subscription-wrapper) {
				max-width: 400px;
				width: 100%;
				background-color: color(black);
			}
		}
	}
</style>
